import { SearchUtils } from '@spotify/confidence-core-react';
import {
  ChatFragment,
  ChatQuery,
  ChatQueryVariables,
  StandardGetHookOptions,
  useChatQuery,
  useChatUpdatedSubscription,
  withStandardGetHook,
} from '@spotify/confidence-graphql';

import { useChatSubscriptionState } from '../useChatSubscriptionState';

export type UseChatOptions = StandardGetHookOptions;

const useChatImpl = withStandardGetHook<
  ChatQuery,
  ChatFragment,
  'chat',
  ChatQueryVariables
>(useChatQuery, 'chat');

export const useChat: typeof useChatImpl = options => {
  const { subscriptionState, onSubscriptionData } = useChatSubscriptionState(
    options.name,
  );

  useChatUpdatedSubscription({
    variables: { filter: `chat.name:${SearchUtils.escapeQuery(options.name)}` },
    skip: !options.name,
    onData: onSubscriptionData,
  });

  const result = useChatImpl(options);

  if (subscriptionState !== null && result.chat) {
    return { ...result, chat: { ...result.chat, state: subscriptionState } };
  }

  return result;
};
